/** @format */

export const HOME = "/";
export const LOGIN = "/login";
export const SIGNUP = "/signup";
export const GENERAL_ERROR = "/general_error";
export const SURVEY_DETAILS = "/surveys/:id"
export const SURVEY_SUBMIT = "/submitSurvey/:id"
